import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { startWith } from 'rxjs/operators';
import { NgbHighlight } from '@ng-bootstrap/ng-bootstrap';
import { Contact, ContactService } from '../../services/contact.service';
import { PaginationComponent } from '../ui/pagination/pagination.component';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbHighlight,
    PaginationComponent,
  ],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit {
  private apiService = inject(ContactService);

  contactArray: Contact[] = [];
  filteredContacts: Contact[] = [];
  page = 1;
  pageSize = 8;
  filter = new FormControl('', { nonNullable: true });

  get pagedContacts(): Contact[] {
    const start = (this.page - 1) * this.pageSize;
    return this.filteredContacts.slice(start, start + this.pageSize);
  }

  ngOnInit(): void {
    this.apiService.getContacts().subscribe((data) => {
      this.contactArray = data.data?.documents || [];
      this.applyFilter();
    });

    this.filter.valueChanges.pipe(startWith('')).subscribe(() => {
      this.page = 1;
      this.applyFilter();
    });
  }

  private applyFilter(): void {
    const term = (this.filter.value ?? '').toLowerCase().trim();
    if (!term) {
      this.filteredContacts = [...this.contactArray];
      return;
    }
    this.filteredContacts = this.contactArray.filter((contact) => {
      return (
        (contact.contactMail || '').toLowerCase().includes(term) ||
        (contact.associatedStudentID || '').toLowerCase().includes(term) ||
        (contact.status || '').toLowerCase().includes(term)
      );
    });
  }
}
